

import { forwardRef } from "react";
import type { ComponentProps } from "react";
import { cn } from "@/lib/utils"

const Textarea = forwardRef<
  HTMLTextAreaElement,
  ComponentProps<"textarea">
>(({ className, spellCheck = true, ...props }, ref) => {
  return (
    <div className="relative group w-full">
      <textarea
        spellCheck={spellCheck}
        className={cn(
          "flex min-h-[80px] w-full px-4 py-3 text-base bg-transparent z-10 relative border border-border/70 rounded-md shadow-none outline-none md:text-sm resize-none text-foreground",
          "placeholder:text-muted-foreground/60",
          "transition-colors duration-200 ease-out",
          "focus:border-primary/80 hover:border-border/90",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    </div>
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
